<template>
  <div class="page-invite">
    <div class="stage">
      <div class="top-bg">
        <img :src="topBgUrl" alt="" class="top-bg-img" />
      </div>

      <div class="custom-top-bar">
        <div class="brand-area">
          <img :src="logo" class="brand-logo" alt="logo" />
          <img :src="brandTextUrl" class="brand-text-img" alt="Kukukao" />
        </div>
        <button class="btn-download" @click="handleOpenApp">下载app</button>
      </div>

      <div class="hero-banner">
        <div class="hero-text">
          <div>来Kukukao</div>
          <div>邀请好友送会员啦</div>
        </div>
        <img :src="mascotProUrl" class="hero-mascot" alt="mascot" />
      </div>

      <div class="card-wrap">
        <div class="invite-card">
          <img :src="cardRectUrl" class="card-rect" alt="" />
          <img :src="cardEllipseUrl" class="card-ellipse left" alt="" />
          <img :src="cardEllipseUrl" class="card-ellipse right" alt="" />

          <div class="card-content">
            <div class="card-head">
              <div class="avatar-wrap">
                <div class="avatar-inner">
                  <img
                    :src="inviteInfo.avatarUrl || defaultAvatarUrl"
                    class="avatar-img"
                    alt="avatar"
                  />
                </div>
                <img
                  v-if="inviteInfo.currentAvatarFrameIconUrl"
                  :src="inviteInfo.currentAvatarFrameIconUrl"
                  class="avatar-frame"
                  alt=""
                />
              </div>
              <div class="head-text">
                <div class="user-name">{{ inviteInfo.userName }}</div>
                <div class="invite-desc">
                  <img :src="inviteDescBgUrl" class="invite-desc-bg" alt="" />
                  <span class="invite-desc-text">邀请你一起来Kukukao学习</span>
                </div>
              </div>
            </div>

            <div class="code-row">
              <div class="code-box">
                <span class="code-text">{{ inviteInfo.shareInviteCode }}</span>
              </div>
              <button type="button" class="btn-copy" @click="copyCode">
                {{ copySuccess ? '已复制' : '复制' }}
              </button>
            </div>

            <div class="cut-divider">
              <img :src="lineSvgUrl" class="divider-line" alt="" />
            </div>

            <div class="instruction">
              注册成为新用户并在好友邀请页面输入邀请码，成功兑换你们都将获得3天的
              <span class="highlight">PRO会员</span>
              ；通过首关，双方再获得4天
              <span class="highlight">PRO会员</span>
              。
            </div>
          </div>
        </div>
      </div>

      <div class="cta-wrap">
        <button class="btn-open" @click="handleOpenApp">打开app查看</button>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo.svg'
import topBg from '@/assets/invite/bg_top.svg'
import mascotPro from '@/assets/invite/mascot_pro.svg'
import cardRect from '@/assets/invite/card_bg.svg'
import cardEllipse from '@/assets/invite/card_hole.svg'
import inviteDescBg from '@/assets/invite/invite_desc_bg.svg'
import lineSvg from '@/assets/invite/divider_line.svg'
import brandText from '@/assets/invite/brand_text.svg'
import defaultAvatar from '@/assets/invite/default_avatar.svg'
import { openApp } from '@/utils/openApp'

export default {
  name: 'HomeInvite',
  props: {
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      logo,
      topBgUrl: topBg,
      mascotProUrl: mascotPro,
      cardRectUrl: cardRect,
      cardEllipseUrl: cardEllipse,
      inviteDescBgUrl: inviteDescBg,
      lineSvgUrl: lineSvg,
      brandTextUrl: brandText,
      defaultAvatarUrl: defaultAvatar,
      copySuccess: false,
      inviteInfo: {
        userName: '',
        avatarUrl: '',
        currentAvatarFrameIconUrl: '',
        shareInviteCode: ''
      }
    }
  },
  computed: {
    userId() {
      return this.query.id || (this.$route && this.$route.query && this.$route.query.id) || null
    }
  },
  mounted() {
      this.fetchInviteInfo()
  },
  methods: {
    async fetchInviteInfo() {
        if (!this.userId) {
            this.error = '缺少用户ID参数'
            this.loading = false
            return
        }

        this.loading = true
        this.error = null

      try {
        const url = `${process.env.VUE_APP_API_BASE_URL || ''}/share/getInviteInfo?userId=${this.userId}`
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        })
        const result = await response.json()
        if (result.code === 200 && result.data) {
          const userName = String(result.data.userName || result.data.nickname || '').trim()
          if (!userName) {
            this.$router.replace('/404')
            return
          }
          this.inviteInfo = {
            userName,
            avatarUrl: result.data.avatarUrl || result.data.avatar || '',
            currentAvatarFrameIconUrl: result.data.currentAvatarFrameIconUrl || '',
            shareInviteCode: result.data.shareInviteCode || ''
          }
        }
      } catch (err) {
        console.error('获取邀请信息失败:', err)
      }
    },
    copyCode() {
      const code = this.inviteInfo.shareInviteCode
      if (!code) return
      if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(() => {
          this.copySuccess = true
          setTimeout(() => {
            this.copySuccess = false
          }, 2000)
        }).catch(() => this.fallbackCopy(code))
      } else {
        this.fallbackCopy(code)
      }
    },
    fallbackCopy(text) {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.setAttribute('readonly', '')
      ta.style.position = 'absolute'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.copySuccess = true
        setTimeout(() => {
          this.copySuccess = false
        }, 2000)
      } catch (e) {
        alert('复制失败，请手动复制：' + text)
      }
      document.body.removeChild(ta)
    },
    handleOpenApp() {
      openApp()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-invite {
  min-height: 100vh;
  background: #e5e5e5;
  padding: 8px;
}

.stage {
  min-height: calc(100vh - 16px);
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #f6f6f6 0 72px, #f97b86 72px, #f4b88d 212px, #ffe6a0 310px, #ffe6a0 100%);
}

.top-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  z-index: 0;
}

.top-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.custom-top-bar {
  position: relative;
  z-index: 2;
  height: 72px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand-area {
  display: flex;
  align-items: center;
}

.brand-logo {
  width: 44px;
  height: 44px;
  margin-right: 10px;
  border-radius: 12px;
  box-sizing: border-box;
}

.brand-text-img {
  width: 91px;
  height: 18px;
  display: block;
}

.btn-download {
  width: 128px;
  height: 48px;
  border: none;
  border-radius: 14px;
  background: #ef5e5a;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
}

.hero-banner {
  position: relative;
  height: 212px;
  padding: 34px 22px 0;
}

.hero-text {
  color: #fff;
  font-size: 25px;
  line-height: 1.5;
  font-weight: 700;
}

.hero-mascot {
  position: absolute;
  right: 18px;
  bottom: 0;
  width: 169px;
  height: 132px;
}

.card-wrap {
  padding: 0 16px;
  margin-top: -8px;
  position: relative;
  z-index: 3;
}

.invite-card {
  position: relative;
  width: 100%;
}

.card-rect {
  width: 100%;
  display: block;
}

.card-content {
  position: absolute;
  inset: 0;
  padding: 28px 18px 0;
}

.card-head {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
}

.avatar-wrap {
  position: relative;
  width: 52px;
  height: 52px;
  margin-right: 12px;
  flex-shrink: 0;
  overflow: visible;
}

.avatar-inner {
  position: absolute;
  left: 6px;
  top: 6px;
  right: 6px;
  bottom: 6px;
  border-radius: 50%;
  overflow: hidden;
  background: #51b7ac;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-frame {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
  font-weight: 700;
}

.head-text {
  min-width: 0;
  flex: 1;
}

.user-name {
  font-size: 18px;
  line-height: 1.5;
  font-weight: 700;
  color: #222;
  margin-bottom: 4px;
}

.invite-desc {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 20px;
  font-size: 14px;
  color: #222;
  line-height: 1.2;
  text-decoration: none;
}

.invite-desc-bg {
  position: absolute;
  left: 0;
  bottom: 2px;
  width: 166px;
  height: 7px;
  z-index: 0;
}

.invite-desc-text {
  position: relative;
  z-index: 1;
}

.code-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.code-box {
  flex: 1;
  height: 56px;
  border-radius: 20px;
  background: #dddddd;
  display: flex;
  align-items: center;
  padding: 0 18px;
  box-sizing: border-box;
}

.code-text {
  font-size: 20px;
  line-height: 1.1;
  color: #ef5e5a;
  font-weight: 700;
  letter-spacing: 2px;
  white-space: nowrap;
}

.btn-copy {
  width: 98px;
  height: 56px;
  border: none;
  border-radius: 20px;
  background: #dfdfdf;
  color: #ef5e5a;
  font-size: 16px;
  font-weight: 700;
}

.cut-divider {
  margin-bottom: 14px;
}

.divider-line {
  display: block;
  width: calc(100% - 16px);
  height: 1px;
  margin-left: 8px;
}

.card-ellipse {
  position: absolute;
  width: 16px;
  height: 16px;
  top: 193px;
}

.card-ellipse.left {
  left: -8px;
}

.card-ellipse.right {
  right: -8px;
}

.instruction {
  font-size: 16px;
  line-height: 1.6;
  color: #7e7e7e;
  text-decoration: none !important;
}

.instruction * {
  text-decoration: none !important;
}

.highlight {
  color: #ffb300;
  font-weight: 700;
}

.cta-wrap {
  padding: 178px 20px 36px;
}

.btn-open {
  width: 100%;
  height: 66px;
  border: none;
  border-radius: 18px;
  background: #ef5e5a;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}
</style>
